import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherForecastIconComponent } from './weather-forecast-icon/weather-forecast-icon.component';

@NgModule({
  exports: [WeatherForecastIconComponent],
  imports: [CommonModule, WeatherForecastIconComponent],
})
export class WeatherForecastModule {}
